<script>
    import DefaultComponent from '../defaultComponent';

    export default {
        ...DefaultComponent,
        props: {
            ...DefaultComponent.props,
            feelabel: String,
            iminterestedlabel: String,
            inWidget: Boolean,
            iminterestedlinkbase: String,
        },
        computed: {
            ...DefaultComponent.computed,
            availability() {
                if (this.item.availability) return JSON.parse(this.item.availability)[0];
                return null;
            },
            registrationLinkObject() {
                if (this.item.registrationLink) return JSON.parse(this.item.registrationLink)[0];
                return null;
            },
            registrationlink() {
                if (this.registrationLinkObject && this.registrationLinkObject.url && this.item.webshopArtcode) {
                    return `${this.registrationLinkObject.url}?artnr=${this.item.webshopArtcode}`;
                } 
                return null;
            },
            iminterestedlink() {
                if (this.iminterestedlinkbase && this.item.name && this.item.id) {
                    const endocdedName = encodeURIComponent(this.item.name);
                    return `${this.iminterestedlinkbase}?name=${endocdedName}&id=${this.item.id}`;
                } 
                return null;
            }
        },
    }
</script>

<template>
    <a :href="item.url" :class="['card', 'eventlink', 'is-shadowless', item.isEducation ? 'is-education' : '']">
        <div v-if="item.imageSets && item.imageSets.length && !inSidebar" class="card-image">
            <source-set :imageSets="item.imageSets" />
            <span v-if="!item.isEducation" class="tag is-medium is-white">{{ toDatesStr(item.startDate, item.endDate) }}</span>
            <span v-show="availability" class="tag is-medium is-primary">
                <span class="icon is-small"><i class="fa-solid fa-bolt-lightning fa-sm"></i></span>
                <span>{{ availability }}</span>
            </span>
        </div>
        <span v-show="inSidebar && !item.isEducation" class="tag is-medium is-white">{{ toDatesStr(item.startDate, item.endDate) }}</span>
        <div :class="['card-content', 'is-flex-grow-1', 'is-flex', 'is-flex-direction-column', contentClass]">
            <h3 v-show="item.name" :class="['title', titleClass]">{{ item.name }}</h3>
            <p v-show="item.intro" :class="['has-text-black', 'mb-3', textClass]">{{ item.intro }}</p>
            <p v-show="item.fee" :class="['has-text-grey-darker', 'mb-3', textClass]">{{ feelabel }}: {{ item.fee }}</p>
            <div v-if="!inSidebar && !inWidget" class="buttons mt-auto is-align-self-flex-end">
                <a v-if="iminterestedlink && !item.hideImInterestedButton" :href="iminterestedlink" class="button is-primary is-outlined no-hover">
                    <span>{{ iminterestedlabel }}</span>
                    <span class="icon"><i class="fa-solid fa-arrow-right-long"></i></span>
                </a>
                <a v-if="!item.isEducation && registrationlink" :href="registrationlink" class="button is-primary no-hover" :target="registrationLinkObject.target">
                    <span>{{ registrationLinkObject.name }}</span>
                    <span class="icon"><i class="fa-solid fa-arrow-right-long"></i></span>
                </a>
            </div>
        </div>
        <span v-show="availability && inSidebar" class="tag is-medium is-primary">
            <span class="icon is-small"><i class="fa-solid fa-bolt-lightning fa-sm"></i></span>
            <span>{{ availability }}</span>
        </span>
    </a>    
</template>
